import { LabelSStyle } from "@components/Typography/TextStyles/LabelS"
import { breakpoints, theme } from "@config/theme"
import { rgba } from "polished"
import styled from "styled-components"

export const FilterCircle = styled.button`
  display: flex;
  align-items: center;
  vertical-align: center;
  position: relative;
  background: ${(p) => p.theme.colors.card.default};
  height: 18vw;
  width: 18vw;
  border-radius: 100%;
  box-shadow: inset 0 0 0 0 ${(p) => rgba(p.theme.colors.purple, 0)};
  transition: background 0.2s ease-in-out, box-shadow 0.01s ease-in-out;
  margin-bottom: 0.25rem;
  outline: 0;
  border: 0;
  cursor: pointer;

  @media screen and (min-width: ${breakpoints.small}) {
    height: 5rem;
    width: 5rem;
  }

  img,
  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  img {
    width: 2.5rem;
    height: 2.5rem;
  }

  svg {
    width: 2rem;
    height: 2rem;
    transition: fill 0.2s ease-in-out;
    fill: ${theme.colors.text.light};

    @media screen and (min-width: ${breakpoints.small}) {
      width: 2.5rem;
      height: 2.5rem;
    }
  }

  &[data-status="active"] {
    box-shadow: inset 0 0 0 2px ${(p) => rgba(p.theme.colors.purple, 1)};
    &[data-showdeactivate="true"] {
      box-shadow: inset 0 0 0 3px ${(p) => rgba(p.theme.colors.purple, 1)};
    }

    svg {
      fill: ${theme.colors.purple};
    }
  }

  &[data-status="disabled"] {
    cursor: not-allowed !important;
    opacity: 0.2;
    pointer-events: none !important;
  }

  &:hover {
    background: ${(p) => p.theme.colors.card.active};
    span:nth-of-type(2) {
      width: 1.25rem;
    }
  }
`

export const FilterContainer = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: center;

  position: relative;
  margin-right: 1rem;
  text-align: center;
`

export const LabelEl = styled.div`
  ${LabelSStyle};
  color: ${(p) => p.theme.colors.text.dark};
  width: 90%;
  margin: 0 auto;
  line-height: 1.1;
`

export const Disable = styled.span`
  background: ${(p) => p.theme.colors.purple};
  height: 1rem;
  position: absolute;
  top: 0.25rem;
  right: 0.25rem;
  width: 1rem;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  opacity: 0;
  transition: all 0.2s ease-in-out;

  &[data-status="active"] {
    transition-delay: 0.2s;
    opacity: 1;
  }

  svg {
    fill: white !important;
    height: 0.5rem;
    width: 0.5rem;
  }
`
